import React from "react";

export const FacebookColored = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0002 2.70825C10.2706 2.70825 7.65292 3.79255 5.72286 5.72261C3.79279 7.65267 2.7085 10.2704 2.7085 12.9999C2.7085 15.7294 3.79279 18.3472 5.72286 20.2772C7.65292 22.2073 10.2706 23.2916 13.0002 23.2916C15.7297 23.2916 18.3474 22.2073 20.2775 20.2772C22.2075 18.3472 23.2918 15.7294 23.2918 12.9999C23.2918 10.2704 22.2075 7.65267 20.2775 5.72261C18.3474 3.79255 15.7297 2.70825 13.0002 2.70825Z"
        fill="#039BE5"
      />
      <path
        d="M14.393 15.7278H17.0564L17.4746 13.0222H14.3925V11.5434C14.3925 10.4195 14.7597 9.4228 15.8111 9.4228H17.5006V7.06167C17.2037 7.02159 16.5759 6.93384 15.3897 6.93384C12.9126 6.93384 11.4604 8.24196 11.4604 11.2222V13.0222H8.91406V15.7278H11.4604V23.1643C11.9647 23.2402 12.4755 23.2916 12.9999 23.2916C13.4738 23.2916 13.9364 23.2483 14.393 23.1865V15.7278Z"
        fill="white"
      />
    </svg>
  );
};
